import "core-js/modules/es.array.concat.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    class: _vm.$style.SimpleCircularTimer
  }, [_c('svg', {
    class: _vm.$style.svgRoot,
    attrs: {
      "viewBox": "0 0 ".concat(_setup.viewBoxSize, " ").concat(_setup.viewBoxSize)
    }
  }, [_c('circle', {
    class: _vm.$style.circle,
    attrs: {
      "cx": _setup.viewBoxSize / 2,
      "cy": _setup.viewBoxSize / 2,
      "r": _setup.radius,
      "stroke": "currentcolor",
      "fill": "none",
      "stroke-width": _setup.thickness,
      "stroke-dasharray": "".concat(_setup.strokeDasharray, " ").concat(_setup.circleLengthMax),
      "stroke-linecap": "round"
    }
  })]), _vm._v(" "), _c('span', {
    class: _vm.$style.seconds
  }, [_vm._v("\n    " + _vm._s(_setup.remainsSeconds) + "\n  ")])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };